import { enUS, es, zhCN, fr, de, nl, it, arSA, tr, th } from 'date-fns/locale';

export const DEFAULT_LOCALE_LANGUAGE = { code: 'en', label: 'English' };

export const RTL_LANGUAGES = ['ar'];

export const localeMap = {
  en: enUS,
  es,
  zh: zhCN,
  fr,
  de,
  nl,
  it,
  ar: arSA,
  tr,
  th,
};

export const supportedLanguages = {
  zh: { value: 'zh', fontFamily: '??????' },
  ja: { value: 'ja', fontFamily: 'NotoSansJP' },
};

export const defaultFontFamily = 'customFont';

export const regexValidation =
  /[^A-Za-z0-9_\u4e00-\u9faF\u3040-\u30FF\u31F0-\u31FF\u0E00-\u0E7F\uFF00-\uFFEF\s]+/gu;
